<template>
  <div>
    <div
      class="flex justify-center items-center w-full"
    >
      <div
        v-if="(minRange > 0) && ((minRange !== maxRange) || inverse)"
        :class="[
          'maxMinText',
          { inverse: inverse }
        ]"
      >
        {{ minRange }}%
      </div>
      <div>
        <div
          class="w-32 h-4 mb-2 mt-1 mx-auto rounded-xl"
          :style="{
            background: minRange === maxRange ? theme : `linear-gradient(${inverse ? '265' : '90'}deg, ${theme}20 0%, ${theme} 100%)`,
          }"
        />
        <div class="text-center text-sm text-base-700">
          {{ caption }}
        </div>
      </div>
      <div
        v-if="(maxRange > 0) && ((minRange !== maxRange) || !inverse)"
        :class="[
          'maxMinText',
          { inverse: inverse }
        ]"
      >
        {{ maxRange }}%
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    minRange: {
      type: Number,
      default: 0,
    },
    maxRange: {
      type: Number,
      default: 0,
    },
    theme: {
      type: String,
      default: '',
    },
    inverse: {
      type: Boolean,
    },
    caption: {
      type: String,
      default: '',
    },
  },
};
</script>
<style scoped>
.maxMinText {
  @apply text-base-900 text-lg font-bold mx-2 self-start;
}
.inverse {
  &:before {
    content: '-';
  }
}
</style>
